import React from "react";
import { SharedLoaderSpinner } from "../shared";

export function GlobalLoader() {
	return (
		<div id="loader" className="loader loader--full" data-at="globalLoader">
			<SharedLoaderSpinner />
		</div>
	);
}
